import { Component, Inject } from '@angular/core';
import { RouterModule } from "@angular/router";
import { IThemeService, themeServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";

@Component( {
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterModule
  ]
} )
export class AppComponent {
  title = 'Zaeper | Digital Signage - Developer Dashboard';

  constructor( @Inject( themeServiceInjectionToken ) private readonly _themeService: IThemeService ) {
  }
}
